var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF4500;stroke:#FF4500;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,1.8c16.6,0,30.1,13.5,30.1,30.1c0,7.1-2.5,14-7.1,19.4L45,78.3l-22.9-27c-4.6-5.4-7.1-12.3-7.1-19.4 C14.9,15.3,28.4,1.8,45,1.8 M45,45.7c8.2,0,14.9-6.7,14.9-14.9c0-8.2-6.7-14.9-14.9-14.9s-14.9,6.7-14.9,14.9 C30.1,39,36.8,45.7,45,45.7 M45,0C27.4,0,13.1,14.3,13.1,31.9c0,7.9,2.9,15,7.6,20.6L45,81.1l24.3-28.6c4.7-5.6,7.6-12.7,7.6-20.6 C76.9,14.3,62.6,0,45,0L45,0z M45,43.9c-7.2,0-13.1-5.9-13.1-13.1c0-7.2,5.9-13.1,13.1-13.1s13.1,5.9,13.1,13.1S52.2,43.9,45,43.9 L45,43.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.3,70.8 57.4,70.8 55.9,72.7 63.3,72.7 71.6,88.2 18.4,88.2 26.7,72.7 34.1,72.7 32.6,70.8  25.6,70.8 15.4,90 74.6,90  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.ed2616cd2b4e995488af8ffb3b40da82.svg";
export { ForwardRef as ReactComponent };